import { ref } from 'vue'
import { defineStore } from 'pinia'
import db from '@/utils/db'
import { MAX_STORAGE_SIZE, MESSAGE_LIST_KEY } from '@/utils/constant'
import type { MessageItemType, ResponseMessageType } from '@/types'

const cwid = sessionStorage.getItem('cwid')
const KEY = MESSAGE_LIST_KEY + '_' + cwid
const history = (db.getJson(KEY) || []) as MessageItemType[]
const pageSize = 10

export const useMessageStore = defineStore('messageStore', () => {
  const messageList = ref<MessageItemType[]>([])
  const hasHistory = ref(!!history.length)
  const isEmpty = ref(history.length === 0)
  function getPrevMessage() {
    if (history.length > 0) {
      const start = Math.max(0, history.length - pageSize)
      const list = history.splice(start, pageSize)
      messageList.value.unshift(...list)
    }
    hasHistory.value = !!history.length
  }

  function messagePush(messages: ResponseMessageType[]) {
    let timestamp = +new Date()
    const arr = messages
      .filter((t) => t.renderCategory !== 'UNKNOWN_CATEGORY')
      .map((item) => {
        Reflect.set(item, 'from', 'other')
        Reflect.set(item, 'timestamp', timestamp++)
        return item
      })
    arr.forEach((item, index) => {
      item.showHeader = index === 0
      switch (item.renderCategory) {
        case 'TABLE': {
          Reflect.set(item, 'sent', false)
          break
        }
      }
    })
    messageList.value.push(...arr)
    saveMessage()
  }

  function saveMessage() {
    const list = [...history, ...messageList.value]
    // 检插大小
    const blob = new Blob([JSON.stringify(list)])
    const size = blob.size
    if (MAX_STORAGE_SIZE < size) {
      let len = Math.floor(list.length / 2)
      if (len > history.length) {
        len -= history.length
        history.splice(0, history.length - 1)
        messageList.value.splice(0, len)
      } else {
        history.splice(0, len - 1)
      }
    }
    let arr = [...history, ...messageList.value]
    arr.sort((prev, next) => {
      return prev.timestamp! > next.timestamp! ? 1 : -1
    })
    let success = false;

    while (!success) {
      try {
        db.setJson(KEY, arr)
        success = true;
      } catch (e) {
        console.error(e);
        if (arr.length >= 500) {
          arr.splice(0, 250);
        } else {
          arr = arr.splice(0, 20);
        }
      }
    }
  }

  return { isEmpty, hasHistory, messageList, getPrevMessage, messagePush, saveMessage }
})
